/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeySecretEc: core.serialization.Schema<serializers.KeySecretEc.Raw, Truvity.KeySecretEc> =
    core.serialization.string();

export declare namespace KeySecretEc {
    export type Raw = string;
}
